<template>
  <div>
  <div class="tabs">
      <div 
        v-for="item in activeTabList" 
        :key="item.id" 
        @click="changeTab(item)" 
        :class="{ 'active_item': activeTab === item.active }"
        style="padding: 10px 20px;"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 会员标签 -->
     <div  v-if="activeTab == 'visitFirst'">
        <div v-if="detail.member_label_name&&detail.member_label_name.length > 0" style="padding-left: 20px;padding-top: 20px;">
          <div v-for="(item, index) in detail.member_label_name" :key="index" style="margin-bottom: 10px;">
             <span style="font-weight: 600;">{{ index+1}}、{{item.name}}:</span>
              <el-tag
                v-for="value in item.children" :key="value" effect="plain" style="margin-left: 15px;margin-bottom: 10px;">
                {{value}}
              </el-tag>
            <span>
            </span>
          </div>  
        </div>
        <div  class="notHave el-icon-picture-outline" v-else>暂无数据</div>

     </div>
     <!-- 图片列表 -->
      <div class="conMsg"  v-if="activeTab == 'visitSecond'">
        <div style="text-align: right;" v-if="oldId == clienId">
          <!-- <el-button class="mt10" size="mini" @click="imgList = true">查看图片</el-button> -->
          <el-button class="mt10" type="primary" size="mini" @click="upImgBtn">上传照片</el-button>
        </div>
        <!-- <div class="top">
          <div class="title">
            <i class="el-icon-collection-tag" />图片列表
          </div>
        </div> -->
        <div class="table">
          <div class="demo-image__preview" v-if="imgsList.length">
            <div class="imgListBox" v-for="item in imgsList" :key="item.id">
              <div class="imgLeft">
                <div class="mb10">
                  <span class="c999 fz12">疤痕类型：</span>
                  {{item.scar_type_name}}
                </div>
                <div class="mb10">
                  <span class="c999 fz12">疤痕部位：</span>
                  {{item.more_name}}
                </div>
                <div class="mb10">
                  <span class="c999 fz12">疤痕成因：</span>
                  {{item.cause_of_formation_name}}
                </div>

                <el-button v-if="(item.haveBtn == 'null' || item.haveBtn == 4) && oldId == clienId" class="mt10" type="primary" size="mini" @click="addCaseBtn(item)">添加案例</el-button>
                <el-button v-if="item.haveBtn == 1 && oldId == clienId" class="mt10" type="primary" size="mini" @click="checkCase(item.caseId)">查看案例</el-button>

              </div>
              <div class="imgRight">
                <div class="itemImg ml20" v-for="(val, index) in item.list" :key="index">
                  <el-image :src="val.src" :preview-src-list="urlList" @click="clickImg(item,val)"></el-image>
                  <el-popconfirm title="确定要删除该图片吗？" @confirm="clickDelImg(val)">
                     <i class="el-icon-circle-close" slot="reference" ></i>
                  </el-popconfirm>
                  <div class="upTime">{{val.create_time}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="notHave el-icon-picture-outline">暂无数据</div>

        </div>
      </div>
      <!-- 核销图片列表 -->
      <div class="conMsg"  v-if="activeTab == 'visitThird'">
        <div class="table">
          <div class="demo-image__preview" v-if="serveList.length">
            <div class="imgListBox" v-for="item in serveList" :key="item.id">
              <div class="imgLeft">
                <div class="mb10">
                  <span class="c999 fz12">时间：</span>
                  {{item.create_time}}
                </div>
                <div class="mb10">
                  <span class="c999 fz12">卡项名称：</span>
                  {{item.name}}
                </div>
                <div class="mb10" v-if="item.category_type_one">
                  <span class="c999 fz12">品项一级：</span>
                  {{item.category_type_one}}
                </div>
                <div class="mb10"  v-if="item.category_type_two">
                  <span class="c999 fz12">品项二级：</span>
                  {{item.category_type_two}}
                </div>
                <div class="mb10">
                  <span class="c999 fz12">操作记录：</span>
                  {{item.remark}}
                </div>

              </div>
              <div class="imgRight">
                <div class="itemImg ml20" v-for="(val, index) in item.img_url" :key="index">
                  <el-image :src="val" :preview-src-list="item.img_url"></el-image>
                  <div class="upTime">{{val.create_time}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="notHave el-icon-picture-outline">暂无数据</div>

        </div>
      </div>

      <!-- 指定信息 -->
      <div class="conMsg" v-if="activeTab == 'visitFourth'">
        <!-- 核查项 -->
         
        <div class="survey-section">
          <div class="survey-title">
            <span>核查项<span class="survey-tip">（出现任一“是”即触发转诊）</span></span>
            <!-- <el-button
              size="mini"
              type="primary"
              icon="el-icon-refresh"
              :loading="surveyLoading"
              @click="loadSurvey"
            >刷新</el-button> -->
          </div>
          <el-table :data="checkList" border size="small" class="survey-table">
            <el-table-column type="index" width="50" align="center" />
            <el-table-column label="问题" min-width="360">
              <template slot-scope="{ row }">
                <span class="check-question" :class="{ 'is-yes': row.answer === '是' }">{{ row.question }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是" width="80" align="center">
              <template slot-scope="{ row }">
                <el-radio v-model="row.answer" label="是">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column label="否" width="80" align="center">
              <template slot-scope="{ row }">
                <el-radio v-model="row.answer" label="否">&nbsp;</el-radio>
              </template>
            </el-table-column>
          </el-table>
          <el-alert
          <el-alert
            v-if="!checkFinished"
            class="survey-alert"
            title="请完成全部核查项；全部选择“否”后，方可填写下方问诊表。"
            type="info"
            :closable="false"
            show-icon
          />
        </div>

        <!-- 问诊信息 -->
        <div class="survey-section" v-if="!surveyDisabled">
          <div class="survey-title">
            <span>问诊表<span class="survey-tip">（选项可多选）</span></span>
          </div>
          <div class="survey-field-wrap">
            <fieldset :disabled="surveyDisabled" class="survey-fieldset">
              <el-table :data="surveyList" border size="small" class="survey-table">
                <el-table-column label="#" type="index" width="50" align="center" />
                <el-table-column label="问题" min-width="200">
                  <template slot-scope="{ row }">{{ row.question }}</template>
                </el-table-column>
                <el-table-column label="选项/填写" min-width="440">
                  <template slot-scope="{ row }">
                    <!-- 单组选项 -->
                    <el-checkbox-group
                      v-if="!row.groups"
                      v-model="row.value"
                      class="opt-group"
                    >
                      <template v-for="opt in row.options">
                        <el-checkbox
                          v-if="typeof opt === 'string'"
                          :key="'s_' + opt"
                          :label="opt"
                        >{{ opt }}</el-checkbox>
                        <el-checkbox
                          v-else
                          :key="'o_' + opt.label"
                          :label="opt"
                        >
                          {{ opt.label }}
                          <template v-if="opt.input">
                            <span v-if="opt.input.before" class="input-affix">{{ opt.input.before }}</span>
                            <el-input
                              v-model="opt.input.value"
                              type="text"
                              size="mini"
                              class="opt1-input"
                              :disabled="!row.value.includes(opt)"
                              :placeholder="opt.input.placeholder"
                            />
                            <span v-if="opt.input.after" class="input-affix">{{ opt.input.after }}</span>
                          </template>
                        </el-checkbox>
                      </template>
                    </el-checkbox-group>
                    <!-- 题尾输入框 -->
                    <el-input
                      v-if="!row.groups && row.tailInput"
                      v-model="row.tailInput.value"
                      size="mini"
                      class="tail-input"
                      :disabled="row.tailInput.linked && !row.value.some(v => typeof v === 'object')"
                    >
                      <template slot="prepend">{{ row.tailInput.prefix }}</template>
                    </el-input>
                    <!-- 多组选项（洗脸习惯/防晒/过敏表现） -->
                    <div v-if="row.groups">
                      <div v-for="(g, gi) in row.groups" :key="'g' + gi" class="opt-group">
                        <span v-if="g.label" class="group-label">{{ g.label }}</span>
                        <el-checkbox-group v-model="g.value">
                          <template v-for="opt in g.options">
                            <el-checkbox
                              v-if="typeof opt === 'string'"
                              :key="'gs_' + gi + opt"
                              :label="opt"
                            >{{ opt }}</el-checkbox>
                            <el-checkbox
                              v-else
                              :key="'go_' + gi + opt.label"
                              :label="opt"
                            >
                              {{ opt.label }}
                              <template v-if="opt.input">
                                <span v-if="opt.input.before" class="input-affix">{{ opt.input.before }}</span>
                                <el-input
                                  v-model="opt.input.value"
                                  size="mini"
                                  class="opt-input"
                                  :disabled="!g.value.includes(opt)"
                                  :placeholder="opt.input.placeholder"
                                />
                                <span v-if="opt.input.after" class="input-affix">{{ opt.input.after }}</span>
                              </template>
                            </el-checkbox>
                          </template>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </fieldset>
            <div v-if="surveyDisabled" class="survey-disabled-mask">
              <i class="el-icon-lock"></i>
              {{ checkAnyYes ? '核查项存在“是”，已触发转诊' : '全部核查项选择“否”后解锁问诊表' }}
            </div>
          </div>
        </div>
        <div class="survey-footer">
          <el-button
            type="primary"
            size="mini"
            :loading="surveySaving"
            @click="submitSurvey"
          >保存</el-button>
        </div>
      </div>


   <!-- <div>
    <el-button
      v-if="detail.is_show_specified == 1"
      class="mb10"
      type="primary"
      size="mini"
      round
      @click="specifiedInfoChange"
    >指定信息修改</el-button>


    <el-button
      v-if="detail.turn_status == 1"
      class="mb10"
      type="primary"
      size="mini"
      round
      @click="hint('turnShop','收到该客户转店')"
    >收到转店</el-button>


    <el-button
      v-if="detail.turn_status == 0||detail.turn_status == 2"
      class="mb10"
      type="primary"
      size="mini"
      round
      @click="turnShop"
    >客户转店</el-button>
    <el-button
      class="mb10"
      type="primary"
      size="mini"
      round
      @click="turnSunmeiShop"
      v-if="userInfo.structure_id == 8 || userInfo.structure_id == 3"
    >客户转双美</el-button>


    <el-button class="mb10" type="primary" size="mini" round @click="openDialog('编辑资料')">编辑资料</el-button>
    <el-button class="mb10" type="primary" size="mini"  v-if="detail.is_two_year_order_service" round @click="applyOpenDialog('消耗申请')">消耗申请</el-button>
    <el-button  v-if="detail.is_show_apply_progress" class="mb10" type="primary" size="mini"   round @click="applyProgress(detail)" >消耗申请进展</el-button>
  </div> -->

    <div class="conMsg">
      <!-- <div class="uderMsg">
        <el-descriptions class="margin-top" :column="3" border>
         <el-descriptions-item>
            <template slot="label">客户名称</template>
            {{detail.customer_name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">手机号码</template>
            {{detail.telephone}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">客户来源</template>
            {{detail.source_name}}
            <span v-if="detail.source_type_id >0">---- {{detail.customer_source_name}}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">归属门店</template>
            {{detail.shop_name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">客户k3代码</template>
            {{detail.king_no}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">治疗进展</template>
            {{detail.progress_name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">疑难级别</template>
            <span v-if="detail.difficulty_level">{{detail.difficulty_level}}级</span>
            <span v-else>暂无</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">客户分类</template>
            {{detail.class_name?detail.class_name:'暂无'}}
          </el-descriptions-item> -->
          <!-- <el-descriptions-item>
            <template slot="label">会员标签</template>
            {{detail.member_label_name}}
          </el-descriptions-item> -->
          <!-- <el-descriptions-item>
            <template slot="label">护理师</template>
            {{detail.nurse_name?detail.nurse_name:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">介绍人</template>
            {{detail.introducer_name?detail.introducer_name:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">外联人</template>
            {{detail.outreach_name?detail.outreach_name:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">地址</template>
            <span
              v-if="detail.province_name"
            >{{detail.province_name}}{{detail.city_name}}{{detail.region_name}}{{detail.detailed_address}}</span>
            <span v-else>未知</span>
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">客户状态</template>
            <span v-if="detail.status">{{detail.status == 1?"启用":'禁用'}}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">年龄</template>
            <span v-if="detail.age">{{detail.age}} 岁，({{detail.birthday}})</span>
            <span v-else>未知</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">性别</template>
            <span v-if="detail.sex">{{detail.sex==1?'男':'女'}}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">疤痕类型/位置</template>
            <div>{{detail.type_position}}</div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">创建时间</template>
            {{detail.create_time?detail.create_time:'暂无'}}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">首次进店时间</template>
            {{detail.first_time?detail.first_time:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">二次进店时间</template>
            {{detail.second_time?detail.second_time:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">自定义标签</template>
            {{detail.tag?detail.tag:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">备注</template>
            {{detail.remarks?detail.remarks:'暂无'}}
          </el-descriptions-item>


          <el-descriptions-item>
            <template slot="label">转介绍顾客姓名</template>
            {{detail.turnName?detail.turnName:'暂无'}}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">转介绍顾客手机号</template>
            {{detail.turnPhone?detail.turnPhone:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">首次到院</template>
            {{detail.reach_first_time?detail.reach_first_time:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">二次到院</template>
            {{detail.reach_second_time?detail.reach_second_time:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">首次线上看诊</template>
            {{detail.consultation_first_time?detail.consultation_first_time:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">二次线上看诊</template>
            {{detail.consultation_second_time?detail.consultation_second_time:'暂无'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">黄V预约方式</template>
            {{detail.consultation_status?detail.consultation_status:'暂无'}}
          </el-descriptions-item>
           <el-descriptions-item>
            <template slot="label"></template>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">是否显示余额</template>
            {{detail.is_show_balance >0?'是':'否'}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">卡项数据是否准确</template>
            {{detail.card_is_correct >0 ? '是':'否'}}
          </el-descriptions-item> 
    
        </el-descriptions>
      </div> -->

      <!-- <div class="conMsg">
        <div class="top">
          <div class="title">
            <i class="el-icon-collection-tag" />统计信息
          </div>
        </div>
        <div class="table">
          <el-table
            :data="detail.blance_list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column label="余额类型" prop="category_name" />
            <el-table-column label="当前余额" prop="all_money" />
            <el-table-column label="本金余额" prop="money" />
            <el-table-column label="赠金余额" prop="complimentary_money" />
            <el-table-column label="店转余额" prop="shop_transfer_money" />
          </el-table>
        </div>
      </div> -->
      <!-- <div class="conMsg">
        <div class="top">
          <div class="title">
            <i class="el-icon-collection-tag" />手机号变更
          </div>
        </div>
        <div class="table">
          <el-table
            :data="detail.change_log"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column label="客户名称" prop="customer_name" /> 
            <el-table-column label="现手机号" prop="telephone" />
            <el-table-column label="原手机号" prop="last_customer_phone" />
            <el-table-column label="变更日期" prop="create_time" />
            <el-table-column label="操作员名称" prop="realname" />
          </el-table>
      </div>
      </div>
      <div class="conMsg">
        <div class="top">
          <div class="title">
            <i class="el-icon-collection-tag" />护理师变更
          </div>
        </div>
        <div class="table">
          <el-table
            :data="detail.nurse_log"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column label="变更日期" prop="time" />
            <el-table-column label="原护理师" prop="old_name" />
            <el-table-column label="变更对象" prop="name" />
          </el-table>
        </div>
      </div> -->



      <!-- 提交案例 -->
      <el-dialog title="提交案例" :visible.sync="addCasePop" width="50%">
        <el-form
        ref="addAnli"
        label-position="right"
        label-width="170px"
        :rules="rulesAddAnli"
        :model="addAnli"
        class="formBox"
      >
          <el-form-item label="案例治疗全流程:" prop="return_visit_record">
            <el-input v-model="addAnli.return_visit_record" class="w300" placeholder="请填写案例治疗全流程" type="textarea" />
          </el-form-item>
          <el-form-item label="是否毕业:">
            <el-radio-group v-model="addAnli.is_excellent">
              <el-radio :label="0">已毕业</el-radio>
              <el-radio :label="1">治疗中</el-radio>
              <el-radio :label="2">治疗中断</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="申请类型:">
            <el-radio-group v-model="addAnli.graduation_type">
              <el-radio :label="0">优秀案例</el-radio>
              <el-radio :label="1">满意案例</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="btnBox">
            <el-button type="primary" size="mini" @click="addCaseForm()">确 定</el-button>
          </div>
         </el-form>
      </el-dialog>

      <!-- 上传图片弹窗 -->
      <el-dialog title="上传图片" :visible.sync="addImg" width="500px">
        <el-form
          ref="imgDetail"
          label-width="100px"
          :rules="rulesImg"
          :model="imgDetail"
          size="mini"
        >
          <el-form-item label="疤痕类型:" prop="scar_type_id">
            <el-select v-model="imgDetail.scar_type_id" placeholder="请选择疤痕类型">
              <el-option
                v-for="item in options.scar_type_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="疤痕部位:" prop="more_id">
            <el-select v-model="imgDetail.more_id" placeholder="请选择疤痕部位">
              <el-option
                v-for="item in options.more_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="疤痕成因:" prop="cause_of_formation_id">
            <el-select v-model="imgDetail.cause_of_formation_id" placeholder="请选择疤痕成因">
              <el-option
                v-for="item in options.cause_of_formation_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="上传图片:">
            <!-- <img-upload :existUrl="existUrl" @setUrl="getUrl" /> -->
            <img-upload
              ref="uploader"
              @setUrl="getImgUrl"
            />
          </el-form-item>
          <div style="text-align: right;">
            <el-button type="primary" size="mini" @click="submitImg('imgDetail')">确 定</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>

    <!-- 转店弹框 -->
    <el-dialog title="客户转店" :visible.sync="dialogVisible" width="40%">
      <el-form
        ref="turnDetail"
        label-position="right"
        label-width="170px"
        :rules="rules"
        :model="turnDetail"
        class="formBox"
      >
        <el-form-item label="转入店铺:" prop="in_shop_id">
          <el-select
            v-model="turnDetail.in_shop_id"
            filterable
            remote
            placeholder="请输入门店名称"
            :remote-method="remoteShop"
            :loading="loading"
            class="w300"
          >
            <el-option
              v-for="item in options.in_shop_id"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="转店备注:" prop="reason">
          <el-input v-model="turnDetail.reason" class="w300" placeholder="请填写转店备注" type="textarea" />
        </el-form-item>
        <el-form-item label="是否短信通知:">
          <el-radio-group v-model="turnDetail.is_information">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="btnBox">
          <el-button type="primary" size="mini" @click="submitForm('turnDetail')">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 双美转店弹框 -->
    <el-dialog title="客户转双美" :visible.sync="dialogSunmeiVisible" width="40%">
      <el-form
        ref="sunmeiDetail"
        label-position="right"
        label-width="170px"
        :rules="sunmeiRules"
        :model="sunmeiDetail"
        class="formBox"
      >
        <el-form-item label="转入店铺:" prop="in_shop_id">
          <el-select
            v-model="sunmeiDetail.in_shop_id"
            filterable
            placeholder="请输入门店名称"
            class="w300"
            @change="getShopDetail"
          >
            <el-option
              v-for="item in options.sunmeiShopList"
              :key="item.shop_id"
              :label="item.shop_name"
              :value="item.shop_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="转店备注:" prop="reason">
          <el-input v-model="sunmeiDetail.reason" class="w300" placeholder="请填写转店备注" type="textarea" />
        </el-form-item>
         <el-form-item label="是否短信通知:">
          <el-radio-group v-model="sunmeiDetail.is_information">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="btnBox">
          <el-button type="primary" size="mini" @click="submitForm('sunmeiDetail')">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

     <!-- 卡项消耗申请弹框 -->
     <el-dialog title="门店预存清理申请" :visible.sync="ApplyDialogVisible" width="40%">
      <el-form
        ref="applyDetail"
        label-position="right"
        label-width="170px"
        :rules="rules"
        :model="applyDetail"
        class="formBox"
      >
        <el-form-item label="申请原因:" prop="reason">
          <el-input v-model="applyDetail.reason" class="w300" placeholder="请填写申请备注" type="textarea" />
        </el-form-item>
      
        <div class="btnBox">
          <el-button type="primary" size="mini" @click="balanceClearApplys()">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 卡项消耗审核流程弹窗 --> 
    <el-dialog
      title="门店预存清零审核流程"
      :visible.sync="applyConsumePop"
      width="40%"
      >
      <div class="block">
        <el-timeline>
          <el-timeline-item timestamp="" placement="top"  >
              <el-card>
                <h4>申请时间:{{ auditDetail.create_time }}</h4>
                <p>申请人：{{ auditDetail.apply_audit_name }}</p>
                <p>申请原因：{{auditDetail.apply_reason}}</p>
                <p >审核状态：<span style="color:red">审核中</span></p>
                <p style="color:red">顾客申请预存清理如下</p>
                <el-table
                  :data="auditDetail.balance"
                  border
                  height="200"
                  show-summary
                  style="width: 100%; margin-top: 20px">
                  <el-table-column
                    prop="type_name"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    prop="money"
                    label="本金">
                  </el-table-column>
                  <el-table-column
                    prop="complimentary_money"
                    label="赠金">
                  </el-table-column>
                  <el-table-column
                    prop="shop_transfer_money"
                    label="店转">
                  </el-table-column>
                </el-table>
              </el-card>
            </el-timeline-item>
          <el-timeline-item timestamp="" placement="top"  v-for="(item) in auditDetailList ">
            <el-card>
              <h4>申请/审核时间:{{ item.apply_audit_time }}</h4>
              <p>申请/审核人：{{ item.apply_audit_name }}</p>
              <p>备注：{{item.apply_audit_reason}}</p>
              <p>审核状态：{{item.is_pass_test }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <!-- <div><el-button type="danger" round >撤销申请</el-button></div> -->
      </div>
    </el-dialog>

     <!-- 指定信息修改 -->
     <el-dialog title="指定信息修改" :visible.sync="dialogSpecifiedVisible" width="40%">
      <el-form
      
        label-position="right"
        label-width="170px"
        :model="sepcifiedDetail"
        class="formBox"
      >
        <el-form-item label="更换客服:" >
          <el-select
            v-model="sepcifiedDetail.service_staff"
            filterable
            placeholder="请输入客服"
            class="w300"
          >
            <el-option
              v-for="item in options.staff"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="更换来源:" >
          <el-select
            v-model="sepcifiedDetail.source_id"
            filterable
            placeholder="请输入来源"
            class="w300"
          >
            <el-option
              v-for="item in options.sourceList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="更换首次进店时间:" >
          <el-date-picker
            v-model="sepcifiedDetail.first_enter_time"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>


        <el-form-item label="更换二次进店时间:" >
          <el-date-picker
            v-model="sepcifiedDetail.second_enter_time"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <div class="btnBox">
          <el-button type="primary" size="mini" @click="setSpecifiedInfo()">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getShopList,shuangmeiShop,transferShopSm } from "@/api/shop";
import imgUpload from "@/components/Upload/imgUpload";
import {
  clientDetail,
  setCustomerStatus,
  transferShop,
  ssettingList,
  customerImgAdd,
  customerImgList,
  customerDel,
  customerAddCase,
  serviceStaff,
  specifiedChange,
  serveContentImage,
  saveCustomerSurvey,
  getCustomerSurveyDetail
} from "@/api/client";
import {
  balanceClearApply,
  auditDetail
} from "@/api/serviceConsume";
import { mapGetters } from 'vuex'
class TurnDetail {
  in_shop_id = "";
  reason = "";
  is_information = 0;
}
class SunmeiDetail {
  market_id = '';
  shop_name = '';
  address = '';
  shop_phone = '';
  in_shop_id = "";
  reason = "";
  is_information = 0;
}

class SpecifiedDetail {
  service_staff = 0;
  source_id = 0;
  first_enter_time = '';
  second_enter_time = '';
}

//卡项消耗申请
class ApplyDetail {
  type = "1";
  reason = "";
}

class Rules {
  in_shop_id = [{ required: true, message: "请选择店铺", trigger: "change" }];
  reason = [{ required: true, message: "请填写备注", trigger: "blur" }];   
}
class SunmeiRules {
  in_shop_id = [{ required: true, message: "请选择店铺", trigger: "change" }];
  reason = [{ required: true, message: "请填写备注", trigger: "blur" }];   
}

// 提交案例------------ start ---------------------
class rulesAddAnli {
  return_visit_record = [{ required: true, message: "请填写案例治疗全流程", trigger: "blur" }];
}

class addAnli {
  addAnliId = "";
  return_visit_record = "";
  is_excellent = 0;
  graduation_type = 0;
}

// 提交案例------------ end ---------------------

class Options {
  apply_type = [{
    id:1,
    value:'张三'
  }];
  in_shop_id = [];
  sunmeiShopList = [];
  scar_type_id = [];
  more_id = [];
  cause_of_formation_id = [];
  sourceList = [];
}
class ImgDetail {
  scar_type_id = "";
  more_id = "";
  src = "";
  cause_of_formation_id = "";
}
class RulesImg {
  scar_type_id = [
    { required: true, message: "请选择疤痕类型", trigger: "change" }
  ];
  more_id = [{ required: true, message: "请选择疤痕部位", trigger: "change" }];
  cause_of_formation_id = [
    { required: true, message: "请选择疤痕成因", trigger: "change" }
  ];
}
export default {
  components: {
    imgUpload
  },
  props: {
    clienId: {
      type: String,
      default: ""
    }
  },
  setup(props){
    watch(()=>props.clienId,(newValue,ordValue)=>{
      console.log(newValue);
    });
  },
  data() {
    return {
      serveList:'',
      activeTab:'visitFirst',
      activeTabList: [
        { name: '客户标签', active: 'visitFirst', id: 1 },
        { name: '图片列表', active: 'visitSecond', id: 2 },
        { name: '核销图片列表', active: 'visitThird', id: 3 },
        { name: '指定信息', active: 'visitFourth', id: 4 },
      ],
      dialogSunmeiVisible:false,
      turnDetail: new TurnDetail(), //转店表单
      sunmeiDetail: new SunmeiDetail(), //转店表单

      applyDetail: new ApplyDetail(), //卡项消耗申请表单
      options: new Options(), //转店表单
      rules: new Rules(),
      sunmeiRules: new SunmeiRules(),
      imgDetail: new ImgDetail(),
      rulesImg: new RulesImg(),
      addAnli: new addAnli(),
      rulesAddAnli: new rulesAddAnli(),
      sepcifiedDetail: new SpecifiedDetail(), //指定信息修改表单
      // addCaseDetail:new addCaseDetail(),
      detail: {},
      dialogVisible: false, //转店弹框
      ApplyDialogVisible: false, //转店弹框
      addCasePop: false, //案例提交弹框
      applyConsumePop:false,  //预存清零审核记录弹窗
      dialogSpecifiedVisible:false,//顾客指定信息修改弹窗
      auditDetailList:[],
      auditDetail:{},
      // 指定信息-核查项（answer: 'yes' / 'no'，任一 yes 触发转诊）
      surveyLoading: false, // 详情加载中（刷新按钮）
      surveySaving: false,  // 保存中（保存按钮）
      checkList: [
        { key: 'check_1', question: '持续性自发泛红、灼热发烫、冷热交替刺痛、情绪/受热立刻潮红（疑似玫瑰痤疮活动期）', answer: '' },
        { key: 'check_2', question: '面部结节、囊肿、脓疱反复渗液（重度感染型痤疮）', answer: '' },
        { key: 'check_3', question: '长期使用速效美白/祛斑/三无产品/激素类药膏，反复爆皮渗液（激素依赖性皮炎）', answer: '' },
        { key: 'check_4', question: '鼻翼、眉间、发际线反复黄白鳞屑、瘙痒、持续泛红出油脱屑（脂溢性皮炎活动期）', answer: '' },
        { key: 'check_5', question: '面部破溃、流水、结痂、感染、不明凸起痣变、快速扩散色斑、反复瘙痒红疹', answer: '' },
        { key: 'check_6', question: '正处皮肤病发作期，或正口服/外用皮肤科处方药物', answer: '' }
      ],
      // 指定信息-问诊表（选项可复选；全部核查项选“否”后解锁）
      surveyList: [
        {
          key: 'sleep_time',
          question: '平均入睡时间',
          value: [],
          options: ['23点前', '23点-1点', '1点后']
        },
        {
          key: 'wash_habit',
          question: '洗脸习惯(水温/频次/工具)',
          groups: [
            { label: '水温：', value: [], options: ['热水烫洗', '温水', '冷水'] },
            { label: '频次：', value: [], options: ['1次', '2次', '>2次'] },
            { label: '工具：', value: [], options: [
              '无',
              { label: '洁面仪/磨砂', input: { before: '每周', after: '次', value: '', placeholder: '' } }
            ] }
          ]
        },
        {
          key: 'efficacy_product',
          question: '近3个月使用功效型产品/项目(酸类/高浓VC/光电/水光/填充)',
          value: [],
          options: [
            '无',
            { label: '有：', input: { value: '', placeholder: '产品/项目' } }
          ],
          tailInput: { prefix: '使用频率：', value: '', linked: true }
        },
        {
          key: 'prescription_drug',
          question: '近6个月口服/外用皮肤科处方药(含激素类药膏)',
          value: [],
          options: [
            '无',
            { label: '有：', input: { value: '', placeholder: '请填写药物' } }
          ]
        },
        {
          key: 'allergy_history',
          question: '护肤品/化妆品过敏史及表现',
          groups: [
            { value: [], options: ['无', '有'] },
            { label: '表现：', value: [], options: ['刺痛红肿', '爆痘', '脱皮'] }
          ]
        },
        {
          key: 'flush_hot',
          question: '冷热交替/情绪激动时面部是否立刻潮红/烧热',
          value: [],
          options: ['否', '是']
        },
        {
          key: 'pregnancy',
          question: '当前是否怀孕/哺乳/备孕',
          value: [],
          options: ['否', '是（全案自动降一档强度，酸类禁用）']
        },
        {
          key: 'sun_protection',
          question: '防晒习惯与户外时长',
          groups: [
            { label: '防晒：', value: [], options: ['硬防晒', '防晒霜', '基本不做'] },
            { label: '户外：', value: [], options: ['<1h', '1-3h', '>3h'] }
          ]
        },
        {
          key: 'diet',
          question: '饮食(高糖高乳/辛辣频率)',
          value: [],
          options: ['很少', '每周2-3次', '几乎每天']
        },
        {
          key: 'improve_wish',
          question: '最想改善的问题及持续时间',
          value: [],
          options: ['毛孔', '黑头', '痤疮', '色素', '松弛', '缺水', '出油'],
          tailInput: { prefix: '已持续', value: '', placeholder: '如：3个月' }
        },
        {
          key: 'living_environment',
          question: '生活及工作环境',
          value: [],
          options: ['经常熬夜', '长期化妆', '经常出差', '长期接触油烟', '辐射', '粉尘']
        }
      ],

      imgsList: [], //图片展示列表
      applyDetail :[],//消耗申请进展
      addImg: false, //图片上传弹框
      loading: false,
      oldId: '',
      urlList: [],
      existUrl: {},
      leadData: [
        {
          money: "￥200.00",
          num: "10"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 核查项是否全部作答
    checkFinished() {
      return this.checkList.length > 0 &&
        this.checkList.every(c => c.answer === '是' || c.answer === '否');
    },
    // 是否任一“是”（触发转诊）
    checkAnyYes() {
      return this.checkList.some(c => c.answer === '是');
    },
    // 全部为否才可填写问诊表
    checkAllNo() {
      return this.checkFinished && this.checkList.every(c => c.answer === '否');
    },
    // 问诊表锁定状态
    surveyDisabled() {
      return !this.checkAllNo;
    }
  },
  mounted() {
    if(this.clienId){
      this.oldId = this.$route.query.id.toString()
    }
    this.getOptions();
    this.getList()
    this.getDetail(this.clienId);
  },
  created() {},
  methods: {
    getList() {
      serveContentImage({
        customer_id: this.clienId,
      }).then(res => {
        this.serveList = res.data;
      });
     // this.getStaff();
    },
    
    changeTab(e) {
      this.activeTab = e.active;
      if(this.activeTab == 'visitThird'){
        this.getList()
      }
      if(this.activeTab == 'visitFourth'){
        this.loadSurvey()
      }
    },
    // 加载指定信息问卷详情（回显）
    loadSurvey() {
      this.surveyLoading = true;
      this.resetSurveyData();
      getCustomerSurveyDetail({ customer_id: this.clienId }).then(res => {
        if (res.data) this.echoSurvey(res.data);
      }).catch(() => {
        this.resetSurveyData();
      }).finally(() => {
        this.surveyLoading = false;
      });
    },
    // 清空问卷答案（保留题目配置）
    resetSurveyData() {
      this.checkList.forEach(c => { c.answer = ''; });
      const clearInputs = options => options.forEach(o => {
        if (typeof o === 'object' && o.input) o.input.value = '';
      });
      this.surveyList.forEach(item => {
        item.value = [];
        clearInputs(item.options || []);
        if (item.groups) item.groups.forEach(g => {
          g.value = [];
          clearInputs(g.options);
        });
        if (item.tailInput) item.tailInput.value = '';
      });
    },
    // 详情数据回显：后端返回的是纯数据，需找回配置中的对象选项引用并回填填空
    echoSurvey(data) {
      const check = data.check || [];
      this.checkList.forEach(row => {
        const saved = check.find(c => c.question === row.question);
        if (saved) row.answer = saved.answer;
      });
      const restoreOptions = (saved, configOptions) => (saved || []).map(v => {
        if (typeof v === 'string') return v;
        const opt = configOptions.find(o => typeof o === 'object' && o.label === v.label);
        if (opt) {
          if (opt.input) opt.input.value = v.input || '';
          return opt;
        }
        return v.label;
      });
      const survey = data.survey || [];
      this.surveyList.forEach(item => {
        const d = survey.find(s => s.question === item.question);
        if (!d) return;
        if (item.groups && d.groups) {
          item.groups.forEach((g, i) => {
            const saved = d.groups[i] || d.groups.find(x => x.label === g.label);
            if (saved) g.value = restoreOptions(saved.value, g.options);
          });
        } else if (d.value) {
          item.value = restoreOptions(d.value, item.options);
        }
        if (item.tailInput && d.tail != null) item.tailInput.value = d.tail;
      });
    },
    // 保存指定信息问卷
    submitSurvey() {
      if (!this.checkFinished) {
        return this.$message.warning('请先完成全部核查项');
      }
      // 归一化选项：对象选项（带填空）转为 { label, input, before?, after? }，字符串选项原样保留
      const normalize = arr => (arr || []).map(v => {
        if (typeof v !== 'object') return v;
        const row = { label: v.label };
        if (v.input) {
          row.input = v.input.value;
          // 输入框前后缀文案一并提交（如 每周 [2] 次）
          if (v.input.before) row.before = v.input.before;
          if (v.input.after) row.after = v.input.after;
        }
        return row;
      });
      const checkArr = this.checkList.map(c => ({ question: c.question, answer: c.answer }));
      const surveyArr = this.surveyList.map(item => {
        const row = { question: item.question };
        if (item.groups) {
          row.groups = item.groups.map(g => ({
            label: g.label || '',
            value: normalize(g.value)
          }));
        } else {
          row.value = normalize(item.value);
        }
        if (item.tailInput) {
          row.tail = item.tailInput.value;
          // 题尾输入框前缀文案一并提交（如 使用频率：[每月1次]、已持续[6个月]）
          if (item.tailInput.prefix) row.tail_prefix = item.tailInput.prefix;
        }
        return row;
      });
      const surveyData = {
        customer_id: this.clienId,
        check_result: this.checkAnyYes ? 'referral' : 'pass',
        check: checkArr,
        survey: this.checkAnyYes ? [] : surveyArr
      };
      this.surveySaving = true;
      saveCustomerSurvey(surveyData).then(res => {
        this.$message.success(res.msg || '问卷已保存');
        // 新增/修改成功后重新拉取详情回显
        this.loadSurvey();
      }).finally(() => {
        this.surveySaving = false;
      });
    },
    getShopDetail(val){
      const targetItem = this.options.sunmeiShopList.find(item => item.shop_id == val);
      this.sunmeiDetail.shop_name = targetItem.shop_name;
      this.sunmeiDetail.address = targetItem.address;
      this.sunmeiDetail.shop_phone = targetItem.shop_phone;
      this.sunmeiDetail.market_id = targetItem.market_id;

    },  
    //顾客预存清零申请进展
    applyProgress(row){

        auditDetail({
            id : row.balanceClearApplyId,
          }).then(res => {
            this.applyConsumePop = true;
            this.auditDetailList = res.data.audit;
            this.auditDetail = res.data.apply;
            console.log(res);
          });
    },
    //顾客预存清零申请
    balanceClearApplys(){
       console.log(this.applyDetail);
       balanceClearApply({...this.applyDetail,customer_id:this.clienId }).then(res => {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.applyDetail.reason = '';
          this.ApplyDialogVisible = false;
          this.getDetail(this.clienId);
      });
    },
    childMethod(){
      console.log('我来了');
    },
    // 获取选项
    getOptions() {
    
      let that = this;
      ssettingList({ page: 1, limit: 100000 }).then(res => {
        res.list.forEach(function(item) {
          if (item.category_id == 1) {
            that.options.scar_type_id.push(item);
          } else if (item.category_id == 2) {
            that.options.more_id.push(item);
          } else if (item.category_id == 3) {
            that.options.cause_of_formation_id.push(item);
          }else if (item.category_id == 4) {
            that.options.sourceList.push(item);
          }
        });
      });
     
      // shuangmeiShop().then(res => {
      //     that.options.sunmeiShopList = res;
      // });
      
      serviceStaff().then(res => {
          that.options.staff = res.data;
      });
    },
    // 获取详情
    getDetail(clienId) {
      console.log(clienId,"this.clienId");

      clientDetail({ id: clienId }).then(res => {
        console.log(res);
        this.detail = res;

        this.sepcifiedDetail.source_id = res.source_id
      
        this.sepcifiedDetail.first_enter_time = res.first_time
        this.sepcifiedDetail.second_enter_time = res.second_time
        this.sepcifiedDetail.service_staff = res.operator
        
        this.$emit("clientDetail", this.detail);
      });
      customerImgList({ customer_id: clienId }).then(res => {
        this.imgsList = res.data.list;
      });
    },
    // 搜索门店
    remoteShop(name) {
      if (name !== "") {
        this.loading = true;
        getShopList({
          shopName: name,
          page: 1,
          limit: 1000000,
          scene: "customer"
        }).then(res => {
          this.loading = false;
          this.options.in_shop_id = res.list;
        });
      } else {
        this.options.in_shop_id = [];
      }
    },
    // 点击上传照片
    upImgBtn() {
      this.addImg = true;
      this.imgDetail = new ImgDetail();
      this.existUrl = {};
    },


    // 上传图片
    getUrl(url) {
      const { absoluteUrl } = url;
      this.imgDetail.src = absoluteUrl;
    },
    // 图片
    getImgUrl({ url }) {
      console.log(url);
      // this.detail.file_path = url.map((val) => val.relativeUrl);
      let srcList = url.map((val) => val.absoluteUrl);
      this.imgDetail.src = srcList
      console.log(url, this.imgDetail.src);

    },
    // 点击图片
    clickImg(item, imgItem) {
      this.imgsList.forEach(val => {
        if (item.id == val.id) {
          let imgList = [];
          val.list.forEach(i => {
            imgList.push(i.src);
          });
          this.urlList = imgList;
        }
      });
    },
    // 点击删除图片
    clickDelImg(val) {
      customerDel({ id: val.id }).then(res => {
        this.$message({
          type: "success",
          message: res.msg
        });
        this.getDetail(this.clienId);
      });
    },
    // 操作
    openDialog(type, row) {
      const query = { detail: this.detail };
      switch (type) {
        case "编辑资料":
          this.$router.push({ name: "客户信息", query });
          break;
      }
    },
    
    turnSunmeiShop(){
      this.sunmeiDetail = new SunmeiDetail();
      this.dialogSunmeiVisible = true;
    },
    // 客户转店弹框
    turnShop() {
      this.dialogVisible = true;
    },
    // 卡项消耗弹框
    applyOpenDialog(){
      this.ApplyDialogVisible = true;
    },
    //指定信息弹窗
    specifiedInfoChange(){
      // this.sepcifiedDetail = new SpecifiedDetail();
      this.dialogSpecifiedVisible =true; 
    },
   
    // 提示
    hint(type, text) {
      this.$confirm(`${text}，是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          switch (type) {
            case "updateTime":
              this.setTime(1);
              break;
            case "turnShop":
              this.setTime(2);
              break;
            case "turnDetail":
              this.setTurnShop();
              break;
            case "sunmeiDetail":
              this.setSunmeiShop();
              break;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 收到转店
    setSpecifiedInfo() {
      this.$confirm('此操作将修改顾客信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          specifiedChange({ customer_id: this.clienId, ...this.sepcifiedDetail }).then(res => {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.getDetail(this.clienId);
            this.dialogSpecifiedVisible= false;
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },



    // 收到转店
    setTime(type) {
      setCustomerStatus({ customer_id: this.clienId, type: type }).then(res => {
        this.$message({
          type: "success",
          message: res.msg
        });
        this.getDetail(this.clienId);
      });
    },
    // 转店提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          
          this.hint(formName, "将当前客户转为此门店");
          console.log(this.turnDetail);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 双美转店
    setSunmeiShop(){
      transferShopSm({ customer_id: this.clienId, ...this.sunmeiDetail }).then(
          res => {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.dialogSunmeiVisible = false;
            this.$router.push({ name: "客户列表" });
          }
        );
    },
    // 确认转店
    setTurnShop() {
      transferShop({ customer_id: this.clienId, ...this.turnDetail }).then(
        res => {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.dialogVisible = false;
          this.$router.push({ name: "客户列表" });
        }
      );
    },
    //上传图片
    submitImg(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.imgDetail.src)
            return this.$message({
              type: "warning",
              message: "请上传照片"
            });
          this.updatedImg();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传图片
    updatedImg() {
      customerImgAdd({
        ...this.imgDetail,
        customer_id: this.clienId,
        shop_id: this.detail.shop_id
      }).then(res => {
        this.$message({
          type: "success",
          message: res.msg
        });
        this.addImg = false;
        this.getDetail(this.clienId);
      });
    },

    // 点击添加案例
    addCaseBtn(obj) {
      console.log(obj);
      this.addAnli.addAnliId = obj.id;
      this.addCasePop = true;
      // console.log(this.imgsList);
    },

    // 申请优案
    addCaseForm(obj) {
      console.log(this.addAnli);
      // console.log(this.imgsList);
      customerAddCase({
        ...this.addAnli,
      }).then(res=>{
        // console.log('1111');
        this.getDetail(this.clienId);
        this.addCasePop = false;
      });
    },

    // 查看案例
    checkCase(id){
      const query = {
        id: id,
        pageName: "案例列表",
        search: '',
        page: ''
      };

      let route = this.$router.resolve({ name: "案例详情", query });
		  window.open(route.href, '_blank');
    }

  }
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
  position: relative;
  display: flex;
  
  div {
    cursor: pointer;
    position: relative;
    &::after {
      content: ''; // 必须设置content属性
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%; // 宽度与选项卡标签一致
      height: 3px;
      background-color: #33bea7;
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: left;
      transform: scaleX(0); // 默认不显示
    }
  }
  
  .active_item {
    color: #33bea7; // 只保留文字颜色变化
    border-bottom: none; // 移除border-bottom
    /* 显示高亮指示器 */
    &::after {
      transform: scaleX(1); // 完全显示
    }
  }
}
.conMsg {
  width: 80%;
  margin-bottom: 30px;
  margin-left: 30px;
  .top {
    display: flex;
    justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 14px;
      line-height: 34px;
      color: #666;
    }
  }
  .table {
    .rowTel {
      border: 1px solid #eee;
      border-right: 0;
      border-top: 0;
      text-align: right;
      padding-right: 30px;
      height: 50px;
      line-height: 50px;
      background: #f9fafc;
      color: #878683;
      font-size: 14px;
    }
    .rowTel2 {
      border-left: 0;
    }
    .rowCon {
      border: 1px solid #eee;
      border-top: 0;
      text-align: left;
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
      background: #fff;
      color: #878683;
      font-size: 14px;
    }
  }
}
.uderMsg {
  display: flex;
  width: 100%;
  .userBox {
    // height: 252px;
    width: 200px;
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-right: 0;
    text-align: center;
    padding-top: 4%;
    box-sizing: border-box;
    .userImg {
      width: 100px;
      height: 100px;
      margin: 0 auto;
      text-align: center;
      line-height: 100px;
      font-size: 16px;
      font-weight: bold;
      color: #666;
      border: 1px solid #eee;
      border-radius: 50%;
    }
    .userRank {
      background: #f04844;
      color: #fff;
      border-radius: 30px;
      width: 100px;
      height: 32px;
      margin: 20px auto 0;
      line-height: 32px;
    }
  }
  .margin-top {
    width: 100%;
  }
}
::v-deep.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  max-width: 309px;
}
.btnBox {
  width: 100%;
  text-align: center;
}
.demo-image__preview {
  // max-height: 60vh;
  // overflow-y: scroll;

  .imgListBox {
    border-bottom: 1px solid #eee;
    padding: 20px 0;
    display: flex;
    position: relative;
  }
  .imgLeft {
    max-width: 30%;
  }
  .imgRight {
    max-width: 70%;
    display: flex;
    flex-wrap: wrap;
  }
  .btnDelImg {
    position: relative;
    right: 0px;
    bottom: 10px;
  }
  .itemImg {
    position: relative;
  }
  .itemImg .el-image {
    width: 120px;
    height: 96px;
    margin-bottom: 10px;
    border-radius: 6px;
  }
  .itemImg .el-icon-circle-close:before {
    font-size: 16px;
    position: absolute;
    right: -5px;
    top: -5px;
    z-index: 66;
    cursor: pointer;
    color: #999;
    background: rgba(255, 255, 255, 0.664);
    border-radius: 50%;
  }
  .upTime {
    font-size: 12px;
    color: #999;
    margin-bottom: 10px;
  }
}
.notHave {
  text-align: center;
  width: 100%;
  padding: 20px 0 40px;
  font-size: 16px;
}
.el-image {
  overflow: unset;
}

.survey-footer {
  margin-top: 12px;
  text-align: right;
}
/* 指定信息问卷 */
.survey-section {
  margin-bottom: 24px;
  .survey-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
    .el-button {
      font-weight: 400;
    }
    .survey-tip {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      margin-left: 6px;
    }
  }
  .survey-alert {
    margin-top: 10px;
  }
  .check-question.is-yes {
    color: #f56c6c;
    font-weight: 600;
  }
  .opt-group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 8px;
    margin-bottom: 6px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-checkbox {
    margin-right: 16px;
    margin-bottom: 0;
    }
  }
  .group-label {
    color: #606266;
    white-space: nowrap;
  }
  .opt1-input {
    min-width: 300px;
  }
  .opt-input {
    width: 110px;
    margin: 0 4px;
  }
  .input-affix {
    color: #606266;
  }
  .tail-input {
    width: 200px;
    margin-top: 8px;
  }
  .survey-field-wrap {
    position: relative;
  }
  .survey-fieldset {
    border: none;
    padding: 0;
    margin: 0;
    min-width: 0;
    &[disabled] {
      opacity: .55;
      cursor: not-allowed;
      .el-checkbox, .el-radio, .el-input {
        cursor: not-allowed;
      }
    }
  }
  .survey-disabled-mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, .55);
    color: #909399;
    font-size: 14px;
    .el-icon-lock {
      margin-right: 6px;
    }
  }
}
</style>
